import { gql } from "@apollo/client";

const recentlyViewedFragment = gql`
    fragment RecentlyViewedModel on Model {
        id
        description
        assetPath
        articleNumber
    }
`;

export const recentlyViewedQuery = gql`
    query RecentlyViewed($modelIds: [String!]!) {
        models(filter: { ids: $modelIds }) {
            nodes {
                ...RecentlyViewedModel
            }
            totalCount
        }
    }
    ${recentlyViewedFragment}
`;
